import { HttpService } from '@services/http.service';
import { Injectable } from '@angular/core';
import _ from 'lodash';

@Injectable({ providedIn: 'root' })
export default class TVBasicService {
  constructor(private httpS: HttpService) { }

  register(requestOpt: any) {
    return this.httpS.post(`/livetv/register`, requestOpt);
  }
}

export { TVBasicService };
